import React from "react"

function IconTrophy({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="trophy"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-trophy"
      {...props}
    >
      <path
        d="m18.11 2.618-.002 3.12h2.62c.325 0 .595.237.645.548l.009.106v1.31c0 2.563-1.188 4.19-3.461 4.718a6.114 6.114 0 0 1-5.267 4.564v3.726h3.28a.655.655 0 0 1 .106 1.3l-.106.01H8.028a.655.655 0 0 1-.106-1.301l.106-.009h3.316l.001-3.727a6.114 6.114 0 0 1-5.306-4.73c-1.817-.631-2.798-2.093-2.874-4.275l-.005-.276v-1.31l.009-.106a.655.655 0 0 1 .54-.54l.106-.008H5.89v-3.12h12.22zm-1.31 1.31H7.2v6.981a4.8 4.8 0 0 0 4.338 4.778l.23.017.232.005a4.8 4.8 0 0 0 4.794-4.567l.006-.233V3.927zm3.273 3.118h-1.965v3.959c1.271-.454 1.904-1.44 1.96-3.06l.005-.243v-.656zm-14.183 0H4.47v.656l.004.244c.048 1.368.507 2.284 1.416 2.81v-3.71z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconTrophy
